import { create } from 'zustand';
import { IProject } from '@packages/global';
import { projectApi } from '../services/user';

interface ProjectState {
  project: IProject | null;
  projectId: string | null;
  loading: boolean;
  error: string | null;
  loadProject: (projectId: string) => Promise<void>;
  updateProjectName: (name: string) => Promise<void>;
  clearProject: () => void;
}

export const useProjectStore = create<ProjectState>((set, get) => ({
  project: null,
  projectId: null,
  loading: false,
  error: null,

  loadProject: async (projectId: string) => {
    // 如果已经加载了相同的项目，不重复加载
    const state = get();
    if (state.projectId === projectId && state.project) {
      return;
    }

    set({ loading: true, error: null, projectId });
    try {
      const project = await projectApi.getProject(projectId);
      set({ project, loading: false });
    } catch (error) {
      console.error('加载项目失败:', error);
      set({ error: '加载项目失败', loading: false });
    }
  },

  updateProjectName: async (name: string) => {
    const { project } = get();
    if (!project) return;

    try {
      await projectApi.updateProject(project.id, { name });
      set({ project: { ...project, name } });
    } catch (error) {
      console.error('更新项目名称失败:', error);
      throw error;
    }
  },

  clearProject: () => {
    set({ project: null, projectId: null, loading: false, error: null });
  }
}));
